module.exports = __webpack_public_path__ + "static/media/mtlogo grad@2x.8e249127.png";